import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth33: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.9,370.3l1.6,7.6,4.6,11.2,4.5,10.1,3.6,9.1,3.1,12.7.8,19.7-1,9.9-4.4,14.9-6.8,8.9-6.9,9.1-30,19.3-14.1,4.5-7.6.2-10.8-2.2-13.9-5.4-9.5-11.4-6.4-16-1.5-13.4-1.2-6.6.2-21.8,3.7-16.8,8.5-28.1,3.4-13.3s34.4-36.9,80.1-2.2h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.8,372.5s34.5-36.8,80.1-2.2l-1.9-8.9s-36.8-30.7-77.4,1.1c0,0-.8,10-.8,10Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.7,456l-.3-15,.5-11.5,6.3-26.8s55.8,32.4-6.4,53.2h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.4,399.1l5,13.6,1.7,10.4.7,18.8-1.7,9.4s-58.5-15.1-5.7-52.2h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M56.3,506.2l-7.1-.8-13.4-5.5-11.1-11.6-6.3-17.4-1.5-14.9-.3-15,.5-11.5,6.3-26.8,4.9-17.3s47.9,64.3,28.2,120.8Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.2,377.9l4.6,10.3,4.6,10.9,5,13.6,1.7,10.4.7,18.8-1.7,9.4-1.7,8.9-2.7,7.6-12.2,15.5-15.5,11.1-17.6,9.2s-14.5-43.7,34.9-125.8Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M82.8,415.4a12.5,12.5 0 1,1 -25,0a12.5,12.5 0 1,1 25,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '18.2 467.9 122.9 467.9 110.1 484.4 93.3 495.8 81.2 502.7 67.6 507.2 57.7 507.1 49 505.8 34.9 500.2 25 488.4 19.8 476.2 18.2 467.9',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.9,370.3l1.6,7.6,4.6,11.2,4.5,10.1,3.6,9.1,3.1,12.7.8,19.7-1,9.9-4.4,14.9-6.8,8.9-6.9,9.1-30,19.3-14.1,4.5-7.6.2-10.8-2.2-13.9-5.4-9.5-11.4-6.4-16-1.5-13.4-1.2-6.6.2-21.8,3.7-16.8,8.5-28.1,3.4-13.3s34.4-36.9,80.1-2.2h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'17.9 441.3 31.8 425.9 35.1 451 46 421.1 54.2 451 64.4 419.6 73.7 449.2 83.8 419.6 92.8 449.5 102.6 419.6 110.1 448.8 115.7 424.8 126.9 442',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'73.3 90.2 65.6 106.1 72.7 113.2 65.2 120.7 72.3 127.9 64.7 135.5 71.8 142.5 64.5 149.8 72.1 157.5 64.7 164.8 71.9 172 64.9 179 72.9 186.9 65.5 194.3 72.2 201.1 64.3 209 71.6 216.3 64.6 223.2 72 230.6 65.3 237.4 72.8 244.9 65.8 251.9 72.2 258.3 66.4 264.1 73 270.7 66.8 276.8 73.4 283.4 66.8 289.9 73 296.1 67 302.1 73.2 308.2 65.7 315.7 72 322.1 65.5 328.6 72 335.2 64.7 342.5 71.6 349.4 63.7 357.3 70.5 364.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'43.6 217.4 48.6 210 53.3 217.6 59 209.3 64.8 217.6 69.6 208.9 74.9 216.2 79.3 210 83 216.7 86.6 209.3 89.6 216.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '27.2 114.5 27.2 101.9 31.8 87.8 40.3 74.8 52.6 61.7 59.2 55.8 72.3 50 79.5 50.4 87.5 53.8 94.3 56.8 100 61 102.1 62.5 115.1 75.1 122.7 84.3 125.4 89.7 129.1 100.9 129.9 104.5 129.9 115 128.7 120.1 118.1 132.2 110.7 136.5 105.9 139.8 100 144.9 80.3 155.4 62.3 155.7 52.8 151.8 43.2 145.2 38.3 140.1 34.1 131.9 29.1 122.2 27.2 114.5',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M45.9,132.9l56.9-.6s-28.3,29.2-56.9.6Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.5,124.9l-3.7-12.9.3-10.2,4.6-12.5s46.8,18.8-1.2,35.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.2,88.6l4.3,10.5.8,3.4.2,12.9-5.6,9.7s-45.5-17.6.3-36.4Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '31.7 89.3 27.1 101.8 26.7 112 30.5 124.9 124.9 125 130.5 115.4 130.3 102.5 125.2 88.6 31.7 89.3',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.2,114.5l1.9,7.7,5,9.7,4.2,8.2,4.9,5.1,9.6,6.6,9.5,3.9,18-.3,19.7-10.5,5.9-5.1,12.2-7.6,10.6-12.1,1.2-5.1s-42.9,16.9-102.7-.5Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.2,114.5v-12.6s4.6-14.1,4.6-14.1l8.5-13,12.3-13.1,6.6-5.9,13.1-5.8,7.2.4,8,3.4,6.8,3,5.7,4.2,15.1,14.1,7.6,9.2,2.7,5.4,3.7,11.2.8,3.6v10.5s-42.7,16.9-102.7-.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'28.2 103 41.1 117.2 44.2 94 54.2 121.7 61.9 94 71.2 123.1 79.9 95.7 89.2 123.1 97.6 95.4 106.6 123.1 113.5 96.1 118.7 118.2 129.1 102.3',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.9,144.5l-1.9-8.4-3.9-11.3-4-15.3-3.4-14.7-1.7-10.1-1-7.7.7-19.9,1.3-10.4,1.9-12,3.7-10.1,9.4-12.4,14.5-7.8,17.7-3.7,14.6,3.7,12.3,6.4,12.8,8.6,10.1,8.6,11.1,13.6,7.1,19.2v19.7l-.9,10.3-3,11.1-4.4,12.3-3.5,7.2-3.7,8.8-2,5.7-1.7,8c-42.4,31.4-82.1.6-82.1.6Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.9,144.5s39.8,30.8,82.1-.6l-1,10.6s-36.4,26.6-80.6-.1l-.5-9.9Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '19.5 39.8 23.3 27.2 27.5 19.5 35 9.7 48.6 3.4 57.8 1.7 66.8 1 75.6 2.3 81.9 4.3 90.3 8.2 100.9 14.5 111.3 21.8 118.5 28.5 126.2 38.8 19.5 39.8',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M50.7,95.8l44.4.2s-20.2,109.6-44.4-.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.1,39.2l-2.8,16.3-.2,20.8,1.6,15.3s69.8-26.7,1.5-52.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M123.6,37.5l4.5,5.5,5.3,16.7.4,4.9.4,17.9-1.2,8.2s-67.7-23.6-9.4-53.2Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M57,2.7l-13.2,3.1-9.4,5.3-8.8,11-5.5,17.1-2.8,16.3-.2,20.8,1.6,15.3,3.2,15.7,4.9,16.9,4.9,11.4S73.7,39,57,2.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M75.3,3.9l9,2.2,10.8,6.1,10.6,6.9,11.6,9.2,6.3,9.2,4.5,5.5,5.3,16.7.8,22.8-1.2,8.2-2.4,10.6-5.5,13.9-8.4,19.4S76.5,61.8,75.3,3.9Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.9,144.5l-1.9-8.4-3.9-11.3-4-15.3-3.4-14.7-1.7-10.1-1-7.7.7-19.9,1.3-10.4,1.9-12,3.7-10.1,9.4-12.4,14.5-7.8,17.7-3.7,14.6,3.7,12.3,6.4,12.8,8.6,10.1,8.6,11.1,13.6,7.1,19.2v19.7l-.9,10.3-3,11.1-4.4,12.3-3.5,7.2-3.7,8.8-2,5.7-1.7,8c-42.4,31.4-82.1.6-82.1.6Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'18.7 74.4 33.2 90.5 36.7 64.2 48.1 95.6 56.7 64.2 67.3 97.2 77.1 66.2 87.7 97.2 97.2 65.8 107.4 97.2 115.2 66.6 121.1 91.7 132.9 73.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'72.2 403.1 79 388.8 72.6 382.5 79.2 375.7 72.7 369.3 79.5 362.4 73.1 356.1 79.6 349.5 72.6 342.8 79.2 336 72.7 329.7 78.9 323.3 71.7 316.3 78.2 309.6 72.1 303.6 79.2 296.4 72.6 289.9 78.7 283.6 72 277 78 270.9 71.2 264.2 77.4 257.9 71.6 252.1 76.7 246.9 70.7 241.1 76.2 235.5 70.3 229.7 76.1 223.7 70.5 218.2 75.8 212.8 70.2 207.3 76.9 200.5 71.1 194.9 76.9 188.9 71 183.1 77.5 176.5 71.2 170.3 78.2 163.1 72.1 157.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'46 286 51 293.6 55.9 285.8 61.7 294.3 67.6 285.8 72.5 294.7 77.9 287.3 82.4 293.6 86.2 286.7 89.8 294.3 92.9 287.1',
			],
		},
	},
};
